import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils/request'

const initialState = {}

export const getModelPlaza = createAsyncThunk<any, any>(
  'getModelPlaza',
  async (arg) => {
    return req({
      url: '/api/model_plaza/get',
      params: {...arg},
    })
  }
)

export const switchModelPlaza = createAsyncThunk<any, any>(
  'switchModelPlaza',
  async (arg) => {
    return req({
      url: '/api/model_plaza/switch',
      params: {...arg},
    })
  }
)

// 社区模型列表（分页）
export const getCommunityModels = createAsyncThunk<any, any>(
  'getCommunityModels',
  async (arg) => {
    return req({
      url: '/api/model_plaza/list_community',
      params: {...arg},
    })
  }
)

// 我的模型列表
export const getMyModels = createAsyncThunk<any, any>(
  'getMyModels',
  async (arg) => {
    return req({
      url: '/api/model_plaza/list_mine',
      params: {...arg},
    })
  }
)

// practical 模式选择模型
export const applyModel = createAsyncThunk<any, any>(
  'applyModel',
  async (arg) => {
    return req({
      url: '/api/model_plaza/use',
      params: {...arg},
    })
  }
)

// 社区/我的模型更新记录
export const getModelUpdateRecords = createAsyncThunk<any, any>(
  'getModelUpdateRecords',
  async (arg) => {
    return req({
      url: '/api/model_plaza/update_records',
      params: {...arg},
    })
  }
)

// 获取当前模型人称视角
export const getModelPov = createAsyncThunk<any, any>(
  'getModelPov',
  async (arg) => {
    return req({
      url: '/api/model_plaza/get_model_pov',
      params: {...arg},
    })
  }
)

// 保存当前模型人称视角
export const saveModelPov = createAsyncThunk<any, any>(
  'saveModelPov',
  async (arg) => {
    return req({
      url: '/api/model_plaza/save_model_pov',
      params: {...arg},
    })
  }
)

// 获取当前选中模型
export const getCurrentModel = createAsyncThunk<any, any>(
  'getCurrentModel',
  async (arg) => {
    return req({
      url: '/api/model_plaza/current',
      params: {...arg},
    })
  }
)

export const getModelPlazaChangelogs = createAsyncThunk<any, any>(
  'getModelPlazaChangelogs',
  async (arg) => {
    return req({
      url: '/api/model_plaza/changelogs',
      params: {...arg},
    })
  }
)

export const markRead = createAsyncThunk<any, any>('markRead', async (arg) => {
  return req({
    url: '/api/model_plaza/mark_read',
    params: {...arg},
  })
})

export const markAllRead = createAsyncThunk<any, any>(
  'markAllRead',
  async (arg) => {
    return req({
      url: '/api/model_plaza/mark_all_read',
      params: {...arg},
    })
  }
)

export const getSubscriptionStatus = createAsyncThunk<any, any>(
  'getSubscriptionStatus',
  async (arg) => {
    return req({
      url: '/api/subscription/get_status',
      params: {...arg},
    })
  }
)

export const markModelPlazaRead = createAsyncThunk<any, any>(
  'markModelPlazaRead',
  async (arg) => {
    return req({
      url: '/api/model_plaza/red_dot_status',
      params: {...arg},
    })
  }
)

export const modelPlazaSlice = createSlice({
  name: 'modelPlaza',
  initialState,
  reducers: {},
  extraReducers: () => {},
})

export default modelPlazaSlice.reducer
